module.exports = __webpack_public_path__ + "front/img/edm-btn.10c604dd.png";